import fetch from 'unfetch';
import useSWRInfinite from 'swr/infinite';

const fetcher = (...args) => fetch(...args).then((res) => res.json());
const urlifyArray = (str) => encodeURIComponent(JSON.stringify(str));
const urlify = (str) => encodeURIComponent(str);

const PAGE_SIZE = 6;

export default function usePages({
  language = 'fi', sortOrder = 'title_asc', categories = [], filters = {},
}) {
  const {
    data, error, size, setSize, isValidating,
  } = useSWRInfinite((index, previousData) => {
    // Last page.
    if (previousData && previousData.pages === index) { return null; }

    return `/wp-json/odl/v1/project-search/?lang=${urlify(language)}&sort=${urlify(sortOrder)}&categories=${urlifyArray(categories)}&filters=${urlifyArray(filters)}&per_page=${PAGE_SIZE}&page=${index + 1}`;
  }, fetcher);

  const isLoadingInitialData = !data && !error;

  return {
    page: data,
    size,
    setSize,
    isValidating,
    isLoadingInitialData,
    isError: error,
  };
}
